import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

/**
 * Landing page when a finder opens the conversation link from an email.
 * Stores the finder token in localStorage (so /conversations/:id renders with it)
 * then redirects to the standard chat page.
 */
export default function FinderConversationRedirect() {
  const { token, convId } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (token) localStorage.setItem(`finder_token_${convId}`, token);
    navigate(`/conversations/${convId}`, { replace: true });
  }, [token, convId, navigate]);
  return (
    <div className="min-h-screen grid place-items-center text-stone-500" data-testid="finder-redirect">
      Connexion à la conversation…
    </div>
  );
}
